import request from "@/http.js";


let data={
  getQuestion:"question/list", // 常见问题
}


export function getQuestion(query) {
  return request({
      url: data.getQuestion,
      method: "post",
      params: query
  });
}



// WEBPACK FOOTER //
// ./src/api/commonProblems/index.js